<template>
  <div class="ew-switch" role="group">
    <div class="ew-switch__thumb bg-primary" :style="thumbStyle"></div>
    <button v-for="opt in options" :key="opt.value" type="button" class="ew-switch__option"
      :class="opt.value === value ? 'is-active text-white' : 'text-muted'" @click="$emit('input', opt.value)">
      <i v-if="opt.icon" :class="'bi ' + opt.icon + ' mr-1'"></i>{{ opt.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'SwitchToggle',
  props: {
    value: { type: String, required: true },
    options: { type: Array, required: true }, // [{ value, label, icon }]
  },
  computed: {
    activeIndex() {
      const idx = this.options.findIndex((o) => o.value === this.value);
      return idx === -1 ? 0 : idx;
    },
    thumbStyle() {
      const n = this.options.length;
      return {
        width: `calc((100% - 8px) / ${n})`,
        transform: `translateX(${this.activeIndex * 100}%)`,
      };
    },
  },
};
</script>

<style scoped>
.ew-switch {
  position: relative;
  display: flex;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 999px;
  padding: 4px;
}

.ew-switch__thumb {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  border-radius: 999px;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.ew-switch__option {
  position: relative;
  z-index: 1;
  flex: 1;
  border: none;
  background: transparent;
  padding: 8px 14px;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 999px;
  cursor: pointer;
  transition: color 0.2s ease;
  white-space: nowrap;
}

.ew-switch__option:focus-visible {
  outline: 2px solid rgba(0, 0, 0, 0.3);
  outline-offset: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/SwitchToggle.vue